import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
export { breadcrumbJsonLd };
import { Link } from "@/components/LocalizedLink";
import { ChevronRight } from "lucide-react";

export type Crumb = { label: string; to?: string };

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Brödsmulor" className="mb-6 text-sm text-muted-foreground">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="inline-flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="h-3.5 w-3.5 opacity-60" />}
              {last || !c.to ? (
                <span aria-current={last ? "page" : undefined} className={last ? "text-foreground" : ""}>
                  {c.label}
                </span>
              ) : (
                <Link to={c.to} className="hover:text-foreground hover:underline">
                  {c.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

